// @ts-nocheck
import * as React from "react";

const PersonAddFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M10 13a7 7 0 0 1 7 7l-.007.117A1 1 0 0 1 16 21H4a1 1 0 0 1-1-1l.004-.24A7 7 0 0 1 10 13Zm0-10a4 4 0 1 1 0 8l-.2-.005A4 4 0 0 1 6 7l.005-.2A4 4 0 0 1 10 3Zm9 1a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0V8h-1a1 1 0 1 1 0-2h1V5a1 1 0 0 1 1-1Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(PersonAddFill);
